import type { SubscriptionKeyType } from '@wegic/price-ui';
import type { GoogleAnalyticsKey } from './types';
import { isBrowser } from '../core/utils';
import { GTAG_MAP } from './const';

/**
 * 根据套餐类型获取 Google Analytics 配置
 * @param type 套餐类型
 * @returns Google Analytics 配置,如果类型无效则返回 null
 */
export function getGtagKey(type: SubscriptionKeyType | undefined): GoogleAnalyticsKey | null {
  if (type === undefined) {
    return null;
  }
  return GTAG_MAP[type] || null;
}

/**
 * 推送事件到 dataLayer
 * @param data 事件数据
 */
export function pushToDataLayer(data: Record<string, any>): void {
  if (!isBrowser()) {
    return;
  }

  if (!window.dataLayer) {
    window.dataLayer = [];
  }

  window.dataLayer.push(data);
}
